import fetchData from "../utils/HttpClient";
import {ModelFilterTagInterface} from "../interfaces/catalog/ModelFilterTagInterface";

export function saveModelFilterTag(modelFilterTag: any): Promise<ModelFilterTagInterface> {
    return fetchData('/api/minda/model-property-tag/save', modelFilterTag, 'POST')
}
export function deleteModelFilterTag(modelFilterTag: ModelFilterTagInterface): Promise<{ status: string }> {
    return fetchData('/api/minda/model-property-tag/delete', modelFilterTag, 'POST')
}

interface ModelFilterTagParams {
    superCategoryId?: number|null,
    repositoryId?: number|null,
}

export function getModelFilterTags(params: ModelFilterTagParams): Promise<ModelFilterTagInterface[]> {
    if(!params['superCategoryId'] && !params['repositoryId']){
        throw Error('Не указан repositoryId или superCategoryId')
    }

    return fetchData('/api/minda/model-property-tag/list', params, 'POST' )
}